module.exports = __webpack_public_path__ + "img/idx-title-download.67e74b0.webp";